/**
 * Get material color classname(s) based on punishment type
 * @param {string} type
 */
export function getSeverityColorHelper(type) {
  switch (type) {
    case "WARN":
      return "amber";
    case "MUTE":
      return "orange";
    case "KICK":
      return "blue";
    case "BAN":
      return "red";
    // unban and unmute colors
    case "PLAYER":
    case "PLAYER_MUTE":
    case "IP":
      return "green";
    default:
      return "gray";
  }
}

/**
 * Get the formatted name of the type
 * @param {string} type
 */
export function getPunishNameHelper(type) {
  switch (type) {
    case "WARN":
      return "WARN";
    case "MUTE":
      return "MUTE";
    case "KICK":
      return "KICK";
    case "BAN":
      return "BAN";
    // unban and unmute names
    case "PLAYER":
      return "UNBAN";
    case "PLAYER_MUTE":
      return "UNMUTE";
    case "IP":
      return "IP UNBAN";
    default:
      return "UNKNOWN";
  }
}

/**
 * Get the name of a material icon based on the punishment type
 * @param {string} type
 */
export function getPunishmentIconNameHelper(type) {
  switch (type) {
    case "WARN":
      return "mdi-exclamation-thick";
    case "MUTE":
      return "mdi-volume-mute";
    case "KICK":
      return "mdi-run";
    case "BAN":
      return "mdi-lock";
    // unban and unmute icon names
    case "PLAYER_MUTE":
      return "mdi-volume-high";
    case "PLAYER":
      return "mdi-lock-open-variant";
    case "IP":
      return "mdi-ip-network";
    default:
      return "mdi-android-messages";
  }
}

/**
 *
 *  @param {string} type
 */
export function punishTypeTextCanExpireHelper(type) {
  switch (type) {
    case "WARN":
      return false;
    case "MUTE":
      return true;
    case "KICK":
      return false;
    case "BAN":
      return true;
    // unban and unmute
    case "PLAYER":
    case "PLAYER_MUTE":
    case "IP":
      return false;
    default:
      return false;
  }
}

/**
 * The participle name of a type
 *  @param {string} type
 */
export function getPunishmentParticipleNameHelper(type) {
  switch (type) {
    case "WARN":
      return "WARNED";
    case "MUTE":
      return "MUTED";
    case "KICK":
      return "KICKED";
    case "BAN":
      return "BANNED";
    // unban and unmute names
    case "PLAYER":
      return "UNBANNED";
    case "PLAYER_MUTE":
      return "UNMUTED";
    case "IP":
      return "IP UNBANNED";
    default:
      return "UNKNOWN";
  }
}
